import React from 'react';
import { useImpersonation } from '../../contexts/ImpersonationContext';
import { UserCircle, X } from 'lucide-react';
import Button from './Button';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedCompanyName, exitImpersonation, isLoading } = useImpersonation();

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex shrink-0 gap-3 items-center justify-between shadow-md">
      <div className="flex items-center gap-3">
        <UserCircle size={20} />
        <span className="font-medium">
          Impersonating: <strong>{impersonatedCompanyName}</strong>
        </span>
        <span className="hidden xl:inline text-amber-100 text-sm">
          — You are viewing the system as this tenant
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={exitImpersonation}
        disabled={isLoading}
        className="text-white hover:bg-amber-600 border border-white/30"
      >
        <X size={16} className="mr-1" />
        {isLoading ? 'Exiting...' : 'Exit Impersonation'}
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
